(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OltSearchController', OltSearchController);

    OltSearchController.$inject = ['$scope', '$rootScope', 'OltData', 'OltService'];

    function OltSearchController($scope, $rootScope, OltData, OltService) {
        var vm = this;

        initialize();

        vm.ipTooltip = 'tooltip.ip.tip';

        vm.changeTooltip = function () {
            if (vm.formSearch.searchIp.$invalid) {
                vm.ipTooltip = 'tooltip.ip.invalid';
            } else {
                vm.ipTooltip = 'tooltip.ip.tip';
            }
        }

        vm.searchOlts = function () {
            if (vm.formSearch.$valid) {
                getList();
            }
        }

        vm.cleanFilter = function () {
            initialize();
            getList();
        }

        function getList() {
            OltData.setArrayOlts([]);
            OltData.requestRunning = true;
            OltService.listOlts(vm.searchData, true).then(function (data) {
                OltData.setArrayOlts(data);
                OltData.requestRunning = false;
            });
        }

        var cancelListener = $rootScope.$on('cleanOltFilter', function () {
            if (vm.searchData.name || vm.searchData.ip) {
                vm.cleanFilter();
            }
        });
        $rootScope.$on('$destroy', cancelListener);

        function initialize() {
            vm.searchData = {
                name: '',
                ip: ''
            };
        }
    }
})();